<template>
  <div class="">
    <b-row class="pt-0">
      <b-col>
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="
              callLogList.length === 0 &&
              !SearchValue.inputValue &&
              !SearchValue.fromDate &&
              !SearchValue.toDate
            " eheader="Call Log" econtent="Call Log" eimg="/src/assets/Img/icons/calllogempty.svg" @createNew="IsAdd"
              :createline="false" />
            <Tableview v-if="
              callLogList.length !== 0 ||
              SearchValue.inputValue ||
              SearchValue.fromDate ||
              SearchValue.toDate
            " :value="callLogList" :paginator="false" class="p-datatable-gridlines" :rows="10" :rowHover="true"
              filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
              :globalFilterFields="globalFilterFields" :filters="filters" :options="logTableList" selectionMode="single"
              @row-click="RowClick" :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false"
              :searchbox1="true" @search="SearchBox" @dateSearch="SearchDate" :sidefilter="true" :filterbtn="true">
              <template v-slot:filter>
                <i class="pi pi-filter tablefilter mx-2" @click="filtervisible = true"></i>
              </template>

              <template v-slot:Status="{ data }">
                <BlueStatus v-if="data.IsActive == '1'" name="Active" />
                <GreyStatus v-if="data.IsActive == '0'" name="In Active" />
              </template>

              <template v-slot:statusData="{ data }">
                <div v-if="data.directionStatus == 'Missed Call'">
                  <img class="callicons" src="../../../../assets/Img/icons/missedcall.svg" />
                  <p>Missed Calls</p>
                </div>
                <div v-if="data.directionStatus == 'Incoming'">
                  <img class="callicons" src="../../../../assets/Img/icons/incomingcall.svg" />

                  <p>Incoming Calls</p>
                </div>
                <div v-if="data.directionStatus == 'Outgoing'">
                  <img class="callicons" src="../../../../assets/Img/icons/outgoingcall.svg" />

                  <p>Outgoing Calls</p>
                </div>
              </template>

              <template v-slot:action="{ data }">
                <span>
                  <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                    @click="toggle($event, data)" />
                </span>
              </template>
            </Tableview>
          </div>
        </div>

        <div v-if="windowWidth <= 545">
          <div v-if="loading">
            <MobileLoader v-for="items in 5" />
          </div>
          <div v-if="!loading">
            <MasterEmpty v-if="
              callLogList.length === 0 &&
              !SearchValue.inputValue &&
              !SearchValue.fromDate &&
              !SearchValue.toDate
            " eheader="Call Log" econtent="Call Log" eimg="/src/assets/Img/icons/calllogempty.svg" @createNew="IsAdd"
              :createline="false" />

            <MobileViewCardHeader @search="SearchBox" @dateSearch="SearchDate" :AddNewHideAndShow="false"
              :totalRecords="rowsCount" :state="state" v-if="
                callLogList.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              ">
              <template v-slot:tablefilter>
                <i class="pi pi-filter tablefilter" @click="filtervisible = true"></i>
              </template>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="items in callLogList">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="name">
                      {{ items.clientNumber }}
                      <span class="callicons"><img v-if="items.type === 'Extension'" class="callicons"
                          src="../../../../assets/Img/icons/outgoingcall.svg" /><img v-else class="callicons"
                          src="../../../../assets/Img/icons/incomingcall.svg" /></span>
                    </p>
                    <i @click="toggle($event, items)" class="pi pi-ellipsis-v"></i>
                  </div>
                  <p class="small-light-txt">
                    <span class="callicons"><img v-if="items.status === 'answered'" class="callicons"
                        src="../../../../assets/Img/icons/callanswer.svg" /><img v-if="items.status === 'missed'"
                        class="callicons" src="../../../../assets/Img/icons/missedcall.svg" /></span>{{
                          items.calldatetime }}
                    <span v-if="items.callDuration && items.status === 'answered'">({{ items.callDuration }})</span>
                  </p>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <WebFilter v-model:visible="filtervisible" @closeside="filtervisible = false" class="websidebar"
    v-if="windowWidth > 545">
    <template v-slot:filterslot>
      <FilterForm :sidedisplay="true">
        <template v-slot:filterslot> </template>
      </FilterForm>
    </template>
  </WebFilter>

  <MobileFIlter v-model:visible="filtervisible" @closeside="filtervisible = false" class="mobsidebar"
    v-if="windowWidth <= 545">
    <template v-slot:filterslot>
      <FilterForm :sidedisplay="true">
        <template v-slot:filterslot> </template>
      </FilterForm>
    </template>
  </MobileFIlter>

  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <!-- <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" /> -->
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <AssignTo v-model:trigger="assignpop" v-if="assignpop" v-model:selected-item="assignpopdata" @load="assignpop = false"
    @close="assignpop = false" @loaderhide="loading = false" @loadershow="loading = false" />

  <CallRecordingView v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
    @load="showDialog = false" @close="showDialog = false" @loaderhide="loading = false" @loadershow="loading = true" />
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  computed,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";

import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import LiveCallService from "../../service/liveCallsService";

import Mapping from "../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../components/FormComponents/Loader.vue";
import { RouterLink, RouterView, useRouter } from "vue-router";
import AssignTo from "../../pages/contact/assignTo.vue";

import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
import ActivatedSuccessfully from "../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../components/FormComponents/InActivateSuccessfully.vue";
import leadSourceCreation from "../../pages/masters/leadSourceMaster/leadSourceCreation.vue";
import CallRecordingView from "../../pages/contact/viewCallRecording.vue";
import { useHotkey } from "v-hotkey3";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../modules/userManagement/Service/AccessControle";
import TextFields from "../../../../components/FormComponents/TextInput.vue";
import moment from "moment";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import MobileViewCardHeader from "../../../../components/FormComponents/MobileViewCardHeader.vue";
import SkeletonTableLoader from "../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileFIlter from "../../../../components/FormComponents/FilterSidebarMobile.vue";
import WebFilter from "../../../../components/FormComponents/FilterSidebarWeb.vue";
import FilterForm from "../../../../components/FormComponents/FilterForm.vue";
import MobileLoader from "../../../../components/SkeletonLoaderComponents/ContactCardView.vue";

export default defineComponent({
  components: {
    TextFields,
    CallRecordingView,
    AssignTo,
    BacktoPage,
    Headerlayout,
    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    leadSourceCreation,
    Datepicker,
    MobileViewCardHeader,
    SkeletonTableLoader,
    MobileFIlter,
    WebFilter,
    FilterForm,
    MobileLoader,
  },
  props: {
    addNew: {
      type: Boolean,
      default: false,
    },
    contactType: {
      type: Number,
      default: 1,
    },
    isFormdata: {
      type: Object,
    },
    logstatus: {
      type: Number,
      default: 1,
    },
    logTableList: {
      type: Array,
      default: [],
    },
    FunctionRights: {
      type: Object,
      default: {},
    },

    DidAndPhoneNumber: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const filter = "";
    const toast = useToast();

    const showmodalref = ref(false);
    const clases = ref(0);
    const childRef = ref();
    let loading1 = ref(false);
    const showDialog = ref(false);
    const rowFocus = ref(false);
    const editItems = ref();
    let assignpop = ref(false);
    let assignpopdata = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const router = useRouter();
    const filtervisible = ref(false);

    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });

    const MappingPop = ref({
      visible: false,
      content: "",
    });

    let loading = ref(false);
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });

    const callLogList: any = ref([]);
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();
    const rowsCount = ref(0);
    debugger;
    let OrganizationId = ref();
    let BranchId = ref();
    let localstoragedata = ref();
    let List = ref([]);

    let filterText = ref({
      textFilter: "",
    });

    debugger;
    let logTableLists: any = ref(props.logTableList);
    let OriginalList: any = ref([]);
    const currentPage = ref(1);
    const perPage = ref(5);
    let mobilerows = ref();
    OriginalList.value = logTableLists.value;
    mobilerows.value = OriginalList.value.length;

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    const headers = [
      {
        header: "S.No",
        field: "rownumber",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        class: "filterdisplaynone",
      },

      {
        header: "Date and Time",
        field: "calldatetime",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Client Name",
        field: "clientName",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Client Number",
        field: "clientNumber",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Call Duration",
        field: "callDuration",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Call Type",
        field: "type",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Status",
        field: "status",
        slot: "Loader",
        slotCopy: "Loader",
        fieldDisplay: "true",
        fieldDisplayCopy: "true",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        class: "filterdisplaynone  last-column-position",
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        fieldDisplay: "false",
        slotCopy: "action",
        fieldDisplayCopy: "false",
        sortable: false,
      },
    ];

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    //

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    onMounted(() => {
      localstoragedata.value = localStorage.getItem("UsersData");
      localstoragedata.value = JSON.parse(localstoragedata.value);
      OrganizationId.value = localstoragedata.value.OrganizationId;
      BranchId.value = localstoragedata.value.BranchId;
      debugger;

      IsShow();

      Object.keys(props.FunctionRights).forEach((key) => {
        if (props.FunctionRights[key])
          Rights.value[key] = props.FunctionRights[key];
      });
    });

    const dataEdit = ref();
    function toggle(event, data) {
      debugger;
      console.log(event);
      editItems.value = data;

      datas.value = data;
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "View Call Records",
            icon: "editicon pi pi-pencil",
            visible: usersData.Admin == 0 ? false : true,
            command: async () => {
              showDialog.value = true;
            },
          },
          {
            label: "Call Records Download",
            icon: "editicon pi pi-pencil",
            visible: false,
            command: async () => {
              IsConfirmDel(datas.value, 3);
            },
          },
        ],
      },
    ]);

    function RowClick(event: any) {
      debugger;

      rowFocus.value = true;
      dataEdit.value = event.data;
      let id, type;
      if (event.data.contactsId != 0 && event.data.leadsId != 0) {
        id = event.data.leadsId;
        type = 1;
      } else if (event.data.contactsId == 0) {
        id = event.data.leadsId;
        type = 1;
      } else if (event.data.leadsId == 0) {
        id = event.data.contactsId;
        type = 0;
      }
      emit("close-dialog");

      router.push({
        path: "contactDetail",
        query: {
          ID: id,
          Type: type,
        },
      });
    }

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    watch(props, (newValue: any) => {
      console.log("props Changed", newValue.FunctionRights);

      Object.keys(newValue.FunctionRights).forEach((key) => {
        if (newValue.FunctionRights[key])
          Rights.value[key] = newValue.FunctionRights[key];
      });
    });

    function IsAdd() {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "adddetailsform",
          query: {
            Type: props.contactType,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmEdit(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data, Status) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else if (Status == 3) {
          contentdel.value = "Download Call Record";
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      BranchId: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RackName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RowName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RooName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },

      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    useHotkey({
      esc: () => {
        closetrigger();
      },
      e: () => {
        IsConfirmEdit(dataEdit.value);
      },
      y: () => { },
      n: () => {
        (Editmodel.value = false), (Deletemodel.value = false);
      },
      d: () => {
        IsConfirmDel(dataEdit.value, 0);
      },
      "ctrl+y": () => { },
      "ctrl+a": () => {
        IsConfirmDel(dataEdit.value, 1);
      },
      "ctrl+d": () => {
        IsConfirmDel(dataEdit.value, 2);
      },
      "alt+n": {
        keydown() {
          IsAdd();
        },
      },
    });
    const paginatedItems = computed(() => {
      const startIndex = (currentPage.value - 1) * perPage.value;
      const endIndex = startIndex + perPage.value;
      return OriginalList.value.slice(startIndex, endIndex);
    });

    function filtereditems() {
      debugger;
      OriginalList.value = logTableLists.value.filter((person) => {
        const searchValue = String(filterText.value.textFilter).toLowerCase();
        return Object.values(person).some((value) =>
          String(value).toLowerCase().includes(searchValue)
        );
      });
    }

    watch(props.DidAndPhoneNumber, (newValue) => {
      debugger;
      alert("dfdfhj ");
    });

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;

        let Flag = 1,
          searchOption = "";

        // let condition =
        //   "cr.ClientNumber='" +
        //   props.DidAndPhoneNumber.phoneNumber +
        //   "' and lc.did='" +
        //   props.DidAndPhoneNumber.DidNumber +
        //   "'";

        //let condition =
        // "cr.ClientNumber='" +
        //props.DidAndPhoneNumber.phoneNumber +
        //"' and cr.DidNumber='" +
        //props.DidAndPhoneNumber.DidNumber +
        //"'";

        let condition =
          "cr.ClientNumber='" +
          props.DidAndPhoneNumber.phoneNumber +
          "'";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        const result = await LiveCallService.CallLogsListCustom(
          SearchValue.value.fromDate,
          SearchValue.value.toDate,
          pageSize,
          pageNum,
          condition,
          Flag,
          searchOption
        );

        console.log(result);

        result["result"] = result["result"].map((item) => {
          // Convert the calldatetime string to a Date object

          const minutes1 = Math.floor(item.callDuration / 60);
          const seconds = item.callDuration % 60;

          // Format callDuration as "X min Y sec"
          item.callDuration = `${minutes1} min ${seconds} sec`;

          return item;
        });

        rowsCount.value =
          result["result"].length > 0 ? result["result"][0]["RowsCount"] : 0;

        callLogList.value = result["result"];

        emit("callLogListlength", callLogList.value.length);
        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    function SearchBox(value) {
      SearchValue.value.inputValue = value;
      state.pagedItems = [];
      state.currentPage = 1;
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      state.totalRows = 0;
      IsShow();
    }

    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";
      state.pagedItems = [];
      state.currentPage = 1;
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      state.totalRows = 0;
      IsShow();
    }

    return {
      currentPage,
      logTableLists,
      perPage,
      mobilerows,
      paginatedItems,
      filterText,
      filtereditems,
      OriginalList,
      assignpopdata,
      assignpop,
      clases,
      List,
      filter,
      Editmodel,
      showmodalref,
      showpopModal: showmodalref,
      childRef,
      IsShow,
      headers,
      loading1,
      filters,
      globalFilterFields,
      filteredColumns,
      showDialog: showDialog,
      editItems,
      RowClick,
      IsAdd,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      dataEdit,
      MappingPop,
      rowsCount,
      loading,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      state,
      callLogList,
      ShowRows,
      SearchBox,
      SearchDate,
      SearchValue,
      filtervisible,
      windowWidth,
    };
  },
});
</script>
<style lang="scss">
.callicons {
  height: 15px;
  width: 15px;
}

.mobile-card {
  .callicons {
    height: 10px;
    width: 10px;
    margin-right: 3px;
  }
}

.overallsearchposition {
  right: 25px;
}

.overallsearch {
  position: relative;
  z-index: 10;
}

.overallSearchicon {
  position: absolute;
}

.tabletop {
  margin-top: -55px;
}
</style>
